<template>
  <modal width="30" :show-modal="showModal" @close-modal="$emit('close-modal')">
    <div>
      <b>Cash Payment</b>
      <!-- <p class="px-3 py-2  w-full max-w-[600px] border-2 text-sm rounded mt-3 opaq-bg">
        A 10% cash handling fee will be added to your total.
      </p> -->
      <div class="flex flex-row pt-4">
        <span class="mr-2 w-10 h-10 rounded-[50px] overflow-hidden mt-1">
          <img src="@/assets/images/icons/paymenticon.svg" />
        </span>
        <div>
          <span class="capitalize opacity-50 text-base font-[600] block w-full">PAYMENT DUE</span>
          <b class="text-base block w-full py-1">₦{{ amountFomatter(costEngine.cost || costEngine.totalCost) }}</b>
        </div>
      </div>
      <!-- <div class="flex flex-row pt-4">
        <span class="mr-2 w-10 h-10 rounded-[50px] overflow-hidden mt-1">
          <img src="@/assets/images/icons/paymenticon.svg" />
        </span>
        <div>
          <span class="capitalize opacity-50 text-base font-[600] block w-full">10% HANDLING FEE</span>
          <b class="text-base block w-full py-1">₦{{ downpayment }}</b>
        </div>
      </div> -->

      <button
      @click="updateTransactionStatus"
      class="font-semibold bg-primary-yellow mt-4 w-full trext-center py-2 rounded">
        Continue
      </button>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    // costEngine: {
    //   type: Object
    // }
  },
  computed: {
    transactionId() {
      return this.$store.getters.latestNewInitialShipping?.transactionId
    },
    costEngine() {
      return this.$store.getters.latestNewCostEngine || this.$store.getters.latestNewCostEngine
    },
    downpayment() {
      let percent = (this.costEngine?.cost || this.costEngine?.totalCost) * 0.1
      return this.amountFomatter(percent)
    }
  },
  data() {
    return {

    }
  },
  mounted() {
  },
  methods: {
    async updateTransactionStatus() {
      try {
        await this.$_updateUserTransaction(this.transactionId, {
          transactionReference: null,
          breakDown: {
            vat: this.costEngine.vat,
            insuranceFee: this.costEngine.insuranceFee,
            handlingCharges: this.costEngine.handlingCharges,
            netPrice: this.costEngine.netPrice,
          },
          payment_type: "cash"
        })
        this.$router.push({ name: "BookingDirection", params: { id: this.$store.getters.latestNewInitialShipping?.id } });
      } catch (error) {
        this.handleError(error)
      }
    },
    closeModal() {
      this.$emit("close-modal");
    },
  }
};
</script>

<style scoped>
.opaq-bg {
  background: rgba(252, 194, 16, 0.15);
  @apply border-primary-yellow
}
</style>